export { TorchHeroSection } from './TorchHeroSection'
